<template>
  <van-dialog
    className="dialog"
    v-model="mShow"
    :showConfirmButton="false"
    :closeOnClickOverlay="true"
  >
    <div class="content column">
      <img class="itemImg" src="../../assets/wheel/text_spdh.png" alt="" />

      <div class="desc" style="margin-top: 50px;" >商品兑换后奖励将立即生效</div>
      <div class="desc">后续将无法参与膨胀</div>

      <div class="btn" @click="exchange">确定</div>
      <div class="btnCancle" @click="close">取消</div>
    </div>
  </van-dialog>
</template>

<script>
import {Toast} from "vant"

export default {
  data() {
    return {
      mShow: false,
      productType:-1,
      productNum:0,
      item:{}
    };
  },

  mounted() {},

  methods: {
    /**
     * productType 商品类型：1 剪辑点 、 2 语音点 、 3 会员天数
     *  productNum 商品值 ,
     */
    open(item) {
      this.item = item;
      this.productType=item.productType;
      this.productNum = item.productNum;
      this.mShow = true;
    },

    exchange(){
      this.$request.POST({
        url:`activity/first/pay/exchange?id=${this.item.id}`,
        success:(obj)=>{
          // Toast({message:"兑换成功！"})
          this.mShow = false;
          this.$emit("exchanged",this.item);
        }
      })
      
    },

    close() {
      this.mShow = false;
      this.$emit("close");
    },


  },
};
</script>

<style scoped>
@import url(../../css/main.css);

.content {
  height: 400px;
  background-image: url(../../assets/wheel/dialog_bg_normal.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

.dialog {
  background: none !important;
}

.itemImg {
  margin-top: 40px;
  width: 120px;
  object-fit: contain;
}


.desc {
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 19px;
  color: #1a1a1a;
  line-height: 20px;
}

.btn {
  margin-top: 50px;
  width: 240px;
  height: 56px;
  background: linear-gradient(90deg, #70aaff 0%, #9362ff 100%);
  border-radius: 56px;
  font-size: 20px;
  color: #ffffff;
  line-height: 56px;
  font-weight: 700;
}

.btnCancle{
  margin-top: 10px;
  width: 240px;
  height: 20px;
  font-size: 20px;
  color: #909090;
  line-height: 20px;
  font-weight: 700;
}
</style>